import { APICore } from "../apiCore";

const api = new APICore();

function fetchGuilds() {
    return api.get('/guild');
}

export { fetchGuilds };
